// extracted by mini-css-extract-plugin
module.exports = {"root":"error_root__y3meQ","container":"error_container__hrAcA","buttons":"error_buttons__E1IzM"};